import { AWCButton, BUTTON_TYPES } from '../GlobalComponents/Inputs/Inputs'

export const PrimaryButtonStory = () => {
    return (
        <AWCButton type={BUTTON_TYPES.PRIMARY} onClick={() => {}} style={{ width: 100 }}>
            Primary
        </AWCButton>
    )
}

export const SecondaryButtonStory = () => {
    return (
        <AWCButton type={BUTTON_TYPES.SECONDARY} onClick={() => {}} style={{ width: 100 }}>
            Secondary
        </AWCButton>
    )
}
export const BlueButtonStory = () => {
    return (
        <AWCButton type={BUTTON_TYPES.BLUE} onClick={() => {}} style={{ width: 100 }}>
            Blue
        </AWCButton>
    )
}
export const LinkButtonStory = () => {
    return (
        <AWCButton type={BUTTON_TYPES.LINK} onClick={() => {}} style={{ width: 100 }}>
            Link
        </AWCButton>
    )
}
export const DisabledButtonStory = () => {
    return (
        <AWCButton type={BUTTON_TYPES.DISABLED} onClick={() => {}} style={{ width: 100 }}>
            Disabled
        </AWCButton>
    )
}
